import { CharterForm } from "./CharterForm";
import { ContactForm } from "./ContactForm";
import { CareerForm } from "./CareerForm";

export const FormSelector = ({form}) => {
    switch (form) {
        case "contact_us":
            return <ContactForm />;
        case "charter":
            return <CharterForm />;
        case "career":
            return <CareerForm />;
        default:
            return null;
    }
};
